export default __webpack_public_path__ + "static/media/screenshot.c722548e.jpg";